import React, { useCallback, useEffect, useState } from "react";

const isDesktopWindow = () => window.innerWidth >= 1370;
const isTabletWindow = () => window.innerWidth < 1370 && window.innerWidth > 600;
const isMobileWindow = () => window.innerWidth <= 600;

const initState = {
    isDesktop: isDesktopWindow(),
    isTablet: isTabletWindow(),
    isMobile: isMobileWindow(),
};

export const MediaContext = React.createContext(initState);

export const MediaContextProvider = (props) => {
    const [isDesktop, setIsDesktop] = useState(isDesktopWindow());
    const [isTablet, setIsTablet] = useState(isTabletWindow());
    const [isMobile, setIsMobile] = useState(isMobileWindow());

    const recalcProps = useCallback(() => {
        setIsDesktop(isDesktopWindow());
        setIsTablet(isTabletWindow());
        setIsMobile(isMobileWindow());
    }, []);

    useEffect(() => {
        recalcProps();
    }, [recalcProps]);

    window.addEventListener("resize", () => {
        recalcProps();
    });

    const context = {
        isDesktop: isDesktop || (!isTablet && !isMobile),
        isTablet,
        isMobile,
    };

    return <MediaContext.Provider value={context}>{props.children}</MediaContext.Provider>;
};
